const checkIfResponseFailed = (response) => {
  if ([400, 503].includes(response.status)) {
    return {
      failed: true,
      data: response
    }
  }
  return {
    failed: false
  }
}

const createPermissions = (user) => {
  const role = user.role_id
  switch (role) {
    case 1:
      user.permissions = {
        isAdmin: true,
        allowDownload: true,
        canAccessAnalytics: true
      }
      break
    case 2:
      user.permissions = {
        isAdmin: false,
        allowDownload: true,
        canAccessAnalytics: true
      }
      break
    case 3:
      user.permissions = {
        isAdmin: false,
        allowDownload: false,
        canAccessAnalytics: false
      }
      break
    case 4:
      user.permissions = {
        isAdmin: false,
        allowDownload: true,
        canAccessAnalytics: false
      }
      break
    default:
      user.permissions = {
        isAdmin: false,
        allowDownload: false,
        canAccessAnalytics: false
      }
      break
  }
  return user
}

export default {
  checkIfResponseFailed,
  createPermissions
}
